import { useState } from 'react';
import { getSourceState } from '@/pages/intelligence/utils/commonUtils';

export default function useSummarySourceState() {

  const [openSource, setOpenSource] = useState(getSourceState());

  const handleClickSourceTips = () => {
    const stateObj = {
      value: !openSource
    };
    localStorage.setItem('dbi_pcconsole_sourcelist_state', JSON.stringify(stateObj));
    setOpenSource(!openSource);
  };

  return { handleClickSourceTips, openSource };
}